
import React, { useState } from 'react';
import { Trash2, SquarePen, Eye, Plus } from 'lucide-react';
import { Search } from 'lucide-react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from '@chakra-ui/react'

const Attechment = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    filename: '',
    Attachedby: '',
    dateadded: '',
    size: '',
  });

  const [Data, setData] = useState([
    {
      filename: 'Document1.pdf',
      Attachedby: 'John Doe',
      dateadded: '2024-04-13',
      size: '1.5mb',
    },
    {
      filename: 'Spreadsheet.xlsx',
      Attachedby: 'Jane Smith',
      dateadded: '2024-04-12',
      size: '750kb',
    },
    {
      filename: 'Presentation.pptx',
      Attachedby: 'Michael Johnson',
      dateadded: '2024-04-13',
      size: '2.2mb',
    },
  ]);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const handleDelete = (index) => {

    const updatedData = [...Data];
    updatedData.splice(index, 1);
    setData(updatedData);
  };

  const heading = [
    { th: 'File Name' },
    { th: 'Attached By' },
    { th: 'Date Added' },
    { th: 'Size' },
    { th: 'Action' },
  ];

  return (
    <>
      <div className='row justify-content-between my-4 mobile-margin' >
        <div className='col-lg-4 col-md-4 col-8'>
          <div className='popup-search d-flex align-items-center bg-white'>
            <input type='search' className='ms-2 my-auto' style={{ outline: "none", border: "none" }} placeholder='Search' />
            <Search size="18px" />
          </div>
        </div>
        <div className='col-4 col-lg-1'>
          <button type='button' className='new-button ms-4 attach-btn' onClick={toggleVisibility}>Attach</button>
        </div>
      </div>
      {isVisible && (
        <div className='row justify-content-center'>
          <div className=' col-lg-12 mb-2'>
            <label htmlFor="imageUpload" className="image-upload" style={{ border: '2px dashed lightgrey', borderRadius: '10px', width: '100%', height: '100px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <div className='w-50 mx-auto'>
                <input className='form-control' type="file" id="imageUpload" name="image" multiple />
                <div className="image-upload-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                  <i className="fas fa-cloud-upload-alt" style={{ fontSize: '24px', marginBottom: '5px' }}></i>
                </div>
              </div>
            </label>
          </div>
        </div>
      )}

      <div className='custom-scroll mt-2' style={{ paddingBottom: '6rem', minHeight: "87vh" }}>
        <TableContainer className='card card-detail pe-0'>
          <Table className='table-space' size='sm'>
            <Thead>
              <Tr className='tr-border'>
                {heading.map((item, index) => (
                  <Th className=" th-color" key={index}>{item.th}</Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {Data.map((item, index) => (
                <Tr key={index} className='tr-border'>
                  <Td>{item.filename}</Td>
                  <Td>{item.Attachedby}</Td>
                  <Td>{item.dateadded}</Td>
                  <Td>{item.size}</Td>
                  <Td>
                    <div className="d-flex gap-1">
                      <i style={{ cursor: 'pointer' }}>
                        <Eye color="#ff176b" size="16px" strokeWidth="1" />
                      </i>
                      <i style={{ cursor: 'pointer' }}>
                        <SquarePen color="#ff176b" size="16px" strokeWidth="1" />
                      </i>
                      <i style={{ cursor: 'pointer' }} onClick={() => handleDelete(index)}>
                        <Trash2 color="#ff176b" size="16px" strokeWidth="1" />
                      </i>
                    </div>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}

export default Attechment;


